// toGetMyThesisList.js

export default {
  state: {
    thesisList: [],
  },
  mutations: {
    AddMyThesisList(state, payload) {
      state.thesisList = payload;
    },
  },
  actions: {},
};
